import { useNavigate, useParams } from "react-router-dom";
import { LoadingButton } from "@mui/lab";
import {
  Button,
  Checkbox,
  Chip,
  Container,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  Paper,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import {
  EstablecimientoProvider,
  useEstablecimientoContext,
} from "./establecimiento-context";
import { coordenadasRegex } from "app/utils/regexps";
import { MdArrowBack } from "react-icons/md";
import { useEstablecimientosContext } from "../establecimientos-context";
import { MunicipioAutocomplete } from "app/components";

export function EstablecimientoForm() {
  return (
    <EstablecimientoProvider>
      <Form />
    </EstablecimientoProvider>
  );
}

function Form() {
  const params = useParams();
  const navigate = useNavigate();

  const {
    addEstablecimiento,
    isAdding,
    updateEstablecimiento,
    isUpdating,
    cancel,
  } = useEstablecimientosContext();

  const { establecimiento, setEstablecimiento, isEditing } =
    useEstablecimientoContext();

  async function handleSubmit(e) {
    e.preventDefault();

    try {
      if (!!isEditing) {
        return await updateEstablecimiento({
          establecimientoId: params.establecimiento_id,
          establecimiento,
        });
      } else {
        return await addEstablecimiento({ establecimiento });
      }
    } catch (error) {
      console.log(error.message);
    }
  }

  return (
    <Container maxWidth="sm" className="animate__animated animate__fadeIn">
      <Paper
        component="form"
        onSubmit={handleSubmit}
        onReset={cancel}
        sx={{ padding: 2 }}
        variant="outlined"
      >
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Stack direction="row" alignItems="center" spacing={1}>
                <Tooltip title="Atrás">
                  <IconButton
                    onClick={() => navigate("../../", { replace: true })}
                  >
                    <MdArrowBack />
                  </IconButton>
                </Tooltip>

                <Typography variant="h6">
                  {`${!!isEditing ? "Editar" : "Agregar"} establecimiento`}
                </Typography>
              </Stack>

              {!!isEditing && (
                <Chip
                  label={
                    !!establecimiento.establecimiento_verificado
                      ? "Verificado"
                      : "Pendiente"
                  }
                  color={
                    !!establecimiento.establecimiento_verificado
                      ? "success"
                      : "warning"
                  }
                  variant="outlined"
                  size="small"
                />
              )}
            </Stack>
          </Grid>

          <Grid item xs={12}>
            <MunicipioAutocomplete
              value={establecimiento.ciudad_id}
              onChange={(value) =>
                setEstablecimiento((establecimiento) => ({
                  ...establecimiento,
                  ciudad_id: value,
                }))
              }
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              type="text"
              label="Dirección detallada"
              value={establecimiento.establecimiento_direccion_detallada}
              onChange={(e) =>
                setEstablecimiento((establecimiento) => ({
                  ...establecimiento,
                  establecimiento_direccion_detallada: e.target.value,
                }))
              }
              size="small"
              fullWidth
              multiline
              rows={3}
              required
              disabled={!!establecimiento.establecimiento_verificado}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              type="text"
              label="Coordenadas (opcional)"
              value={establecimiento.establecimiento_coordenadas}
              onChange={(e) =>
                setEstablecimiento((establecimiento) => ({
                  ...establecimiento,
                  establecimiento_coordenadas: e.target.value,
                }))
              }
              inputProps={{
                pattern: coordenadasRegex.pattern,
                title: coordenadasRegex.title,
              }}
              size="small"
              fullWidth
              disabled={!!establecimiento.establecimiento_verificado}
            />
          </Grid>

          <Grid item xs={12}>
            <FormGroup>
              <FormControlLabel
                disabled={!!establecimiento.establecimiento_verificado}
                control={
                  <Checkbox
                    checked={establecimiento.establecimiento_principal}
                    onChange={(e) =>
                      setEstablecimiento((establecimiento) => ({
                        ...establecimiento,
                        establecimiento_principal: e.target.checked,
                      }))
                    }
                  />
                }
                label="¿Es un establecimiento principal?"
              />
            </FormGroup>
          </Grid>

          {!establecimiento.establecimiento_verificado && (
            <Grid item xs={12}>
              <Stack direction="row" justifyContent="end" spacing={1}>
                <LoadingButton
                  type="submit"
                  variant="contained"
                  size="small"
                  color={!!isEditing ? "warning" : "success"}
                  loading={!!isUpdating || !!isAdding}
                >
                  {!!isEditing ? "Actualizar" : "Agregar"}
                </LoadingButton>

                <Button
                  type="reset"
                  variant="outlined"
                  size="small"
                  color="inherit"
                  disabled={!!isUpdating || !!isAdding}
                >
                  Cancelar
                </Button>
              </Stack>
            </Grid>
          )}
        </Grid>
      </Paper>
    </Container>
  );
}
